import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { CurrencyService } from '@fantaz/shared/utils';

@Component({
  selector: 'fz-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyComponent {
  @Input()
  value?: number;
  #currencyService: CurrencyService = inject(CurrencyService);
  @Input()
  highlightCredit = false;

  get dollar(): string {
    return `${this.#currencyService.convertDollar(this.value)} USD`;
  }
}
